import Features from './features';
import Photo from './photo';
import Dimensions from './dimensions';
import Specifications from './specifications';
import Table from './table';
import PhotoGallery from './photo-gallery';
import CtaBox from '../components/cta-box';
import TestimonialList from '../components/testimonial-list';
import ContentBoxList from '../components/content-box-list';
import LargeBox from '../components/large-box';
import Title from '../components/title';
import Hero from '../components/hero';
import { useGlobalContext } from '../lib/global-context';

export default function SectionTree({ section, isTrust = false }) {

    const { state } = useGlobalContext();

    const specs = section.filter((component) => component.__component === 'layout.specification-list');

    let specSize = '';
    if (specs.length == 1) {
        specSize = 'md:w-full';
    }
    if (specs.length == 2) {
        specSize = 'md:w-1/2';
    }
    if (specs.length == 3) {
        specSize = 'md:w-1/2 xl:w-1/3';
    }

    return (
        <>
            {section.map((component, index) => (
                <>
                    {!isTrust && (
                        <>
                            {component.__component !== 'layout.large-box' && (<section>
                                <div className={state.galleryStatus ? `` : `relative z-10`}>
                                    <div className="container pt-10  ">
                                        <Component key={`comp-${index}`} component={component} specSize={specSize} />
                                    </div>
                                </div>
                            </section>
                            )}
                            {component.__component === 'layout.large-box' &&
                                <Component key={`comp-${index}`} component={component} specSize={specSize} />
                            }
                        </>
                    )}
                    {isTrust && (
                        <Component key={`comp-${index}`} component={component} specSize={specSize} />
                    )}
                </>
            ))
            }
        </>
    );
}

const Component = ({ component, specSize = '' }) => {
    switch (component.__component) {
        case 'layout.feature-list':
            return <Features key={component.__component} {...component} />;
        case 'layout.photo':
            return (
                <div key={component.__component} className="max-w-screen-xl mx-auto py-20 px-20 items-center" >
                    <Photo {...component} />
                </div>
            );
        case 'layout.gallery':

            return (
                <PhotoGallery key={component.__component} {...component} className="px-10"></PhotoGallery>
            );
        case 'layout.dimension-list':
            return (
                <div key={component.__component} className="inline-block p-4 mt-8 w-full lg:w-1/2 align-top">
                    <Dimensions {...component} />
                </div>
            );
        case 'layout.specification-list':
            return (
                <div key={component.__component} className={`inline-block p-4 mt-8 w-full ${specSize} align-top specification-list`}>
                    <Specifications {...component} />
                </div>
            );
        case 'layout.cta':
            return <CtaBox key={component.__component}  {...component} />;
        case 'layout.table':
            return (
                <div key={component.__component} className="inline-block p-4 mt-8 w-full align-top">
                    <Table {...component} />
                </div>
            );
        case 'layout.content-block':
            return (
                <div key={component.__component} className="relative">
                    <span dangerouslySetInnerHTML={{ __html: component.title }}></span>
                    <span dangerouslySetInnerHTML={{ __html: component.content }}></span>
                </div>
            );
        case 'layout.large-box':
            return <LargeBox key={component.__component} {...component} />;
        case 'layout.title':
            return <Title key={component.__component} {...component} />;
        case 'layout.cta':
            return <CtaBox key={component.__component} {...component} />;
        case 'layout.testimonial-list':
            return <TestimonialList key={component.__component} {...component} />;
        case 'layout.hero':
            return <Hero key={'hero' + section.id} type="home" settings={section} />;

    }
}
